import type { NotifyPort } from '@/features/messages/domain/notify'
import type { ChatPort, Message } from '../domain/chat'

const listMessages = async (
	port: ChatPort,
	topicId: string,
	before: number,
	limit: number,
	notify: NotifyPort,
): Promise<Message[]> => {
	try {
		return await port.listMessages(topicId, before, limit)
	} catch {
		notify.error('chat.messagesLoadFailed')
		return []
	}
}

export { listMessages }
